import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

export const HeaderContainer = styled.div<{ includeBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(props) => (props.includeBorder ? '1px solid #e0e0e0' : 'none')};
  flex: 0 0 auto;
  padding-bottom: 10px;
  background-color: ${p4Tokens.colorHeaderBackground};
  width: 100%;
`;

HeaderContainer.defaultProps = {
  includeBorder: false,
};

export default HeaderContainer;
